import React from "react"
import PropTypes from "prop-types"
import { graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Card = (props) => {
  const { name, slug, service, summary, thumbnail } = props

  return (
    <div className="min-h-96">
      <Link to={`/case-studies/${slug}/`}>
        <GatsbyImage
          image={thumbnail.localFile.childImageSharp.gatsbyImageData}
          alt={thumbnail.title}
          className="filter hover:brightness-75 transition-all duration-300 ease-out z-10"
        />
      </Link>

      <div className="p-4">
        <Link
          to={`/case-studies/${slug}/`}
          className="flex items-start justify-between pr-1 hover:pr-0 transition-spacing ease-out"
        >
          <h3 className="transition-colors hover:text-softGreen-900 pt-1 text-2xl leading-7 md:leading-8 md:text-3xl">
            {name}
          </h3>

          <IconArrow />
        </Link>

        <h4 className="text-base leading-6 font-semibold text-softGreen-800 mb-4">
          {service}
        </h4>

        <p className="body-text-normal">{summary}</p>
      </div>
    </div>
  )
}

const IconArrow = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 mt-1 md:mt-2 ml-3 flex-shrink-0"
    >
      <path
        d="M20 6.66675L18.12 8.54675L24.2267 14.6667H2.66666V17.3334H24.2267L18.1067 23.4534L20 25.3334L29.3333 16.0001L20 6.66675Z"
        fill="#0D293C"
      />
    </svg>
  )
}

Card.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  thumbnail: PropTypes.shape({
    localFile: PropTypes.object,
  }),
}

export default Card

export const query = graphql`
  fragment CaseStudyCard on ContentfulCaseStudy {
    id
    name
    slug
    thumbnail {
      localFile {
        childImageSharp {
          gatsbyImageData(
            width: 768
            height: 384
            quality: 95
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
      title
    }
    summary
    service
  }
`
